import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";

@Component({
  selector: "app-changepassword",
  templateUrl: "./changepassword.component.html",
  styleUrls: ["./changepassword.component.css"],
})
export class ChangepasswordComponent implements OnInit {
  apiUrl: string;
  changePasswordForm: FormGroup;
  submitted = false;
  dtOptions: any = {};

  fieldTextType1: boolean;
	fieldTextType2: boolean;
	fieldTextType3: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService,
    private utility: UtilityService
  ) {}

  ngOnInit() {
    this.initialiseForm();
    this.initTable();
  }

  initTable() {
    this.dtOptions = {
      paging: true,
      scrollX: true,
      pagingType: "full_numbers",
      responsive: true,
      pageLength: 10,
      lengthChange: true,
      processing: true,
      ordering: false,
      info: true,
      columnDefs: [
        {
          //targets: [ 10 ],
          visible: false,
          searchable: false,
        },
      ],
      dom:
        "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        // { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
        // { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
      ],
    };
  }

  initialiseForm() {
    this.changePasswordForm = this.formBuilder.group(
      {
        currentPassword: ["", [Validators.required]],
        newPassword: [
          "",
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
            ),
          ],
        ],
        confirmNewPassword: [
          "",
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
            ),
          ],
        ],
      },
      { validator: this.utility.MustMatch("newPassword", "confirmNewPassword") }
    );
  }

  onSubmit(formData) {
    this.submitted = true;

    if (this.changePasswordForm.invalid) {
      return;
    }

    var requestObj = {
      email: localStorage.getItem("email"),
      current_password: formData.currentPassword,
      new_password: formData.newPassword,
      confirm_password: formData.confirmNewPassword,
    };

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.spinnerService.show();

    this.apiUrl = environment.AUTHAPIURL + "users/change-password";

    this.http
      .post<any>(this.apiUrl, requestObj, { headers: reqHeader })
      .subscribe((data) => {
        this.spinnerService.hide();

        if (data.status == true) {
          this.changePasswordForm.reset();
          Object.keys(this.changePasswordForm.controls).forEach((key) => {
            this.changePasswordForm.get(key).setErrors(null);
          });
          this.submitted = false;


          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
  }

  toggleFieldTextType1() {
		this.fieldTextType1 = !this.fieldTextType1;
	}

	toggleFieldTextType2() {
		this.fieldTextType2 = !this.fieldTextType2;
	}

	toggleFieldTextType3() {
		this.fieldTextType3 = !this.fieldTextType3;
	}
}
